import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Fields, FormSection } from 'redux-form';
import { propArrayShape, propBool, propId, propStr, } from '../../../../../helpers/custom-prop-types';
import ColumnSyncCheckBox from './ColumnSyncCheckBox';
const CheckBoxListColumnSyncComponent = memo((props) => {
    const { id, isDisabled, lists, name } = props;
    const viewName = useMemo(() => {
        const middle = lists.find((v) => v.id.toString() === id.toString());
        return middle ? middle.name : '';
    }, [lists, id]);
    const names = useMemo(() => ['check', 'especially'], []);
    return (_jsx(FormSection, Object.assign({ name: `${name}[${id}]` }, { children: _jsx(Fields, { component: ColumnSyncCheckBox, isDisabled: isDisabled, label: viewName, names: names }) })));
});
CheckBoxListColumnSyncComponent.propTypes = {
    id: propId().isRequired,
    isDisabled: propBool().isRequired,
    lists: propArrayShape().isRequired,
    name: propStr().isRequired,
};
export default CheckBoxListColumnSyncComponent;
